import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import MKBox from 'components/MaterialKit/MKBox';
import DataTable from 'components/DataTable';
import { parseJSON } from 'utils/general';
import MKTypography from 'components/MaterialKit/MKTypography';

const BuddhistContactTableSection = ({
  data,
  columns,
  odd_row_background_color,
  even_row_background_color,
  odd_row_font_color,
  even_row_font_color,
  header_background_color,
  header_font_color,
  container_props,
  ...props
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
    const handleMobileChange = (event) => {
      setIsMobile(event.matches);
    };
    mobileMediaQuery.addEventListener('change', handleMobileChange);
    setIsMobile(mobileMediaQuery.matches);
    return () => {
      mobileMediaQuery.removeEventListener('change', handleMobileChange);
    };
  }, []);

  const renderData = () => {
    const headers = columns.map((column) => column.field);
    return data.map((datum, index) => {
      return (
        <MKBox display="flex" mb="2rem">
          <MKBox
            display="flex"
            flex={1}
            flexDirection="column"
            padding="1rem"
            sx={{ backgroundColor: header_background_color }}
          >
            {columns.map((column) => (
              <MKTypography color={header_font_color}>{column.label}</MKTypography>
            ))}
          </MKBox>
          <MKBox
            display="flex"
            flex={2}
            flexDirection="column"
            padding="1rem"
            sx={{ backgroundColor: index % 2 === 0 ? even_row_background_color : odd_row_background_color }}
          >
            {headers.map((header) => (
              <MKTypography
                color={index % 2 === 0 ? even_row_font_color : odd_row_font_color}
              >
                {datum[header]}
              </MKTypography>
            ))}
          </MKBox>
        </MKBox>
      );
    });
  };

  return (
    <MKBox
      sx={{
        ...parseJSON(container_props, {}),
      }}
      {...props}
    >
      {isMobile ? (
        <MKBox>
          {renderData()}
        </MKBox>
      ) : (
        <DataTable
          data={data}
          columns={columns}
          headerBackgroundColor={header_background_color}
          headerFontColor={header_font_color}
          oddRowBackgroundColor={odd_row_background_color}
          oddRowFontColor={odd_row_font_color}
          evenRowBackgroundColor={even_row_background_color}
          evenRowFontColor={even_row_font_color}
          paginationDisabled
        />
      )}
    </MKBox>
  );
};

BuddhistContactTableSection.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.object,
  odd_row_background_color: PropTypes.string,
  even_row_background_color: PropTypes.string,
  odd_row_font_color: PropTypes.string,
  even_row_font_color: PropTypes.string,
  header_background_color: PropTypes.string,
  header_font_color: PropTypes.string,
  container_props: PropTypes.string,
};

BuddhistContactTableSection.defaultProps = {
  columns: [],
  data: [],
  odd_row_background_color: '',
  even_row_background_color: '',
  odd_row_font_color: '',
  even_row_font_color: '',
  header_background_color: '',
  header_font_color: '',
  container_props: '',
};

export default BuddhistContactTableSection;
